module.exports = __webpack_public_path__ + "static/MinionPro-MediumCapt-b814b77b93310e020058e4095399b240.woff";